<wl-rich-text-wrapper [field]="{ value: productBenefits }">
  <div class="horizontal-list"></div>
</wl-rich-text-wrapper>
@if (contactInformation) {
  <hr class="mb-3" />
}
<wl-rich-text-wrapper [field]="{ value: contactInformation }">
  <div class="footer-note-sm"></div>
</wl-rich-text-wrapper>
